{
  "schemaVersion": 1,
  "id": "default",
  "version": "0.1",
  "faceMaterialId": "ply-face-birch",
  "edgeMaterialId": "ply-edge-birch",
  "hardwareAssetIds": [],
  "textureScaleMetres": 1.0,
  "bevelRadiusMm": 0.6,
  "lightingPresetId": "softbox-three-area",
  "notes": "Library preset consumed by the Blender job. Never changes the manufacturing hash."
}
